import React, { useState } from "react";
import { Visibility } from "@mui/icons-material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { Colors } from "../../../../constants/Colors";
import { Fleet } from "../../../../types/fleets.types";
import { toReais } from "../../../../utils/functions";

interface Props {
  fleet: Fleet;
}

const DAY_LABELS: Record<string, string> = {
  MONDAY: "Segunda",
  TUESDAY: "Terça",
  WEDNESDAY: "Quarta",
  THURSDAY: "Quinta",
  FRIDAY: "Sexta",
  SATURDAY: "Sábado",
  SUNDAY: "Domingo",
};

const ViewFleetSettings: React.FC<Props> = ({ fleet }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Visibility
        sx={{
          color: Colors.primary[100],
          cursor: "pointer",
          ":hover": { opacity: "70%" },
        }}
        onClick={() => setOpen(true)}
      />
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>Regras — {fleet.description}</DialogTitle>
        <DialogContent>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Dia</TableCell>
                <TableCell>Hora início</TableCell>
                <TableCell>Hora fim</TableCell>
                <TableCell>Tipo de desconto</TableCell>
                <TableCell>Desconto</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {fleet.rules?.length ? (
                fleet.rules.map((r, i) => (
                  <TableRow key={i}>
                    <TableCell>{r.weekDay ? (DAY_LABELS[r.weekDay] ?? r.weekDay) : "Todos"}</TableCell>
                    <TableCell>{r.startHour ?? "—"}</TableCell>
                    <TableCell>{r.endHour ?? "—"}</TableCell>
                    <TableCell>
                      {r.discountType === "PERCENTAGE" ? "Porcentagem" : "Valor"}
                    </TableCell>
                    <TableCell>
                      {r.discountType === "PERCENTAGE"
                        ? `${r.discount}%`
                        : toReais(r.discount)}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5}>Sem regras cadastradas.</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Fechar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ViewFleetSettings;
